import { render, staticRenderFns } from "./DefaultMonitor.vue?vue&type=template&id=6646d434&scoped=true&"
import script from "./DefaultMonitor.vue?vue&type=script&lang=js&"
export * from "./DefaultMonitor.vue?vue&type=script&lang=js&"
import style0 from "./DefaultMonitor.vue?vue&type=style&index=0&id=6646d434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646d434",
  null
  
)

export default component.exports